import { Stack, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Skeleton from "@mui/material/Skeleton"
const skeletonSx = {
  backgroundColor: "#EBEBEB",
  my: "12px",
  ml: 2
}
export default function FindingEditorSkeletion() {
  const skeletonWidths = ["30%", "35%", "90%", "90%", "25%"]
  return (
    <Box sx={{ backgroundColor: "#FFFFFF", borderRadius: "4px" }}>
      <Box>
        <Stack direction="column" justifyContent="center">
          {skeletonWidths?.map((width, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              height={30}
              width={width}
              sx={skeletonSx}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  )
}